import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52ad188f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bookMenusAffix" }

import { ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'SubMenusBook',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const activeName = computed(() => useRoute().params.type);

const handlerTabClick = (pane: { props: { name: string } }) => {
  router.push({
    name: "helpBooks",
    params: {
      type: pane.props.name,
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_affix = _resolveComponent("el-affix")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, { offset: 100 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tabs, {
          modelValue: _unref(activeName),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(activeName) ? (activeName).value = $event : null)),
          "tab-position": "left",
          class: "bookMenusTabs",
          onTabClick: handlerTabClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('user_tut.web_use'),
              name: "web-use"
            }, null, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('user_tut.dec_install'),
              name: "dec-install"
            }, null, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('user_tut.dec_functions'),
              name: "dec-use"
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}
}

})